import React from 'react';
import { UseFormReturn, RegisterOptions } from 'react-hook-form';
import Input from 'components/Input';
import FieldController from 'components/FieldController';

type FieldProps = {
  form: UseFormReturn<any>;
  name: string;
  type: string;
  placeholder?: string;
  defaultValue?: string;
  maxLength?: number;
  rules?: RegisterOptions;
  maskPlaceholder?: string;
  inputRef?: any;
  icon?: React.ReactNode;
  className?: string;
  labelClassname?: string;
  editable?: boolean;
  onChangeText?: (v: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  mask?: (value: string) => string;
  mapper?: (value: React.ChangeEvent<HTMLInputElement>) => string;
  loading?: boolean;
  disabled?: boolean;
  autoComplete?: string;
  handleKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  focusOnChevronClick?: boolean;
};

const Field = ({
  form,
  name,
  rules,
  mask,
  mapper,
  maxLength,
  onChangeText,
  maskPlaceholder,
  inputRef,
  icon,
  onBlur,
  defaultValue,
  editable = false,
  onFocus,
  handleKeyDown,
  focusOnChevronClick,
  ...restOfProps
}: FieldProps): JSX.Element => (
  <FieldController
    name={name}
    defaultValue={defaultValue}
    form={form}
    rules={rules}
    mask={mask}
    mapper={mapper}
    render={({ field, onChange, error, onValueTransform }) => {
      const onInputChangeText = (text: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(text);
        onChangeText?.(text);
      };

      const handleFocus = () => {
        if (onFocus) onFocus();
        form.clearErrors(name);
      };

      const handleBlur = () => {
        if (onBlur) onBlur();
        field.onBlur();
      };

      return (
        <Input
          error={error}
          maxLength={maxLength}
          maskPlaceholder={maskPlaceholder}
          icon={icon}
          onChangeText={onInputChangeText}
          {...restOfProps}
          {...field}
          onFocus={handleFocus}
          onBlur={handleBlur}
          ref={inputRef}
          value={onValueTransform(field.value)}
          onKeyDown={handleKeyDown}
          focusOnChevronClick={focusOnChevronClick}
        />
      );
    }}
  />
);

export default Field;
